module.exports = __webpack_public_path__ + "img/3AT2315.0ff22fed.jpg";